import { render, staticRenderFns } from "./settingsdialog.vue?vue&type=template&id=7a2c3cf6&"
import script from "./settingsdialog.vue?vue&type=script&lang=ts&"
export * from "./settingsdialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports